import { FC } from "react";
import { GaugeChartProps } from "@/storybook/c8r-highcharts/gauge-chart/utils/types";
import { ChartErrorBoundary } from "@/storybook/c8r-highcharts/ChartErrorBoundary";
import { GaugeChart } from "@/storybook/c8r-highcharts/gauge-chart/GaugeChart";

export const HighchartsGaugeChart: FC<GaugeChartProps> = (props) => (
  <ChartErrorBoundary>
    <GaugeChart {...props} />
  </ChartErrorBoundary>
);
